'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';

export const coachManagementModule = angular
  .module('app.coachManagement', [])
  .config(coachManagementConfig);

coachManagementConfig.$inject = ['$routeProvider'];

function coachManagementConfig($routeProvider) {
  $routeProvider
    .when('/coach-list', {
      template: '<ngz-coach-list list-mode="NUTRITION"></ngz-coach-list>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/coach-list/scan-iq', {
      template: '<ngz-coach-list list-mode="SCAN_IQ"></ngz-coach-list>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/coach-setup', {
      template: '<ngz-coach-setup></ngz-coach-setup>',
      resolve: getLoginRequiredResolveObj(),
    });
}
